// Platform detection utilities
export const isNativePlatform = () => {
  return typeof window !== 'undefined' && (
    window.navigator.userAgent.toLowerCase().includes('electron') ||
    window.navigator.userAgent.toLowerCase().includes('capacitor') ||
    window.navigator.userAgent.toLowerCase().includes('cordova')
  );
};

export const isWebPlatform = () => {
  return typeof window !== 'undefined' && !isNativePlatform();
};

export const isNotificationSupported = () => {
  return typeof window !== 'undefined' && 
         typeof Notification !== 'undefined' && 
         !isNativePlatform();
};

export const isIOS = () => {
  return typeof window !== 'undefined' && (
    /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
  );
};

export const isAndroid = () => {
  return typeof window !== 'undefined' && /Android/.test(window.navigator.userAgent);
};

export const isMobile = () => {
  return isIOS() || isAndroid();
};

export const isDesktop = () => {
  return !isMobile() && !isNativePlatform();
}; 